const getQueryParam = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const newParams = new URLSearchParams(
    Array.from(queryParams, ([key, value]) => [key.toLowerCase(), value])
  );

  return newParams;
};

const GetLangId = langCode => {
  if (langCode) {
    switch (langCode.toLowerCase()) {
      case 'pt':
        return '-6';
      case 'zh':
        return '-7';
      case 'cs':
        return '-27';
      case 'de':
        return '-3';
      case 'da':
        return '-28';
      case 'es':
        return '-5';
      case 'fi':
        return '-24';
      case 'fr':
        return '-2';
      case 'hu':
        return '-31';
      case 'it':
        return '-4';
      case 'ja':
        return '-10';
      case 'ko':
        return '-9';
      case 'nl':
        return '-29';
      case 'nb':
        return '-25';
      case 'pl':
        return '-22';
      case 'ru':
        return '-20';
      case 'sv':
        return '-26';
      case 'th':
        return '-32';
      case 'tr':
        return '-30';
      case 'tw':
        return '-8';
      case 'en':
        return '-1';
      case 'vi':
        return '-34';
    }
  } else return '-1';
};

export { getQueryParam, GetLangId };
